import {
  handleResp,
  getDefaultHeaders,
  extendFetchOptions,
  CommonResponse,
} from "./utils";
import type { WrappedCashifyFunction, GenericResponse } from "./utils";
import type { StandardObject } from "utils";

export interface TenantConfigurationService {
  getTenantConfiguration: ReturnType<typeof getTenantConfiguration>;
  putTenantConfiguration: ReturnType<typeof putTenantConfiguration>;
  putTenantConfigurationStatus: ReturnType<typeof putTenantConfigurationStatus>;
  dryrun: ReturnType<typeof performDryrun>;
}

// Tenant Configuration
export interface TenantConfigurationDTO {
  id: number;
  tenantId: number;
  configurationName: string;
  configuration: StandardObject;
  enabled?: boolean;
  revision?: number;
  lastUpdateTime?: string;
  lastUpdateAdmin?: string;
}

export const getTenantConfiguration: WrappedCashifyFunction<
  { name: string },
  GenericResponse<TenantConfigurationDTO>
> = ({ urlPrefix, options }) => {
  return async ({ name }) => {
    let url = `${urlPrefix}/api/v1/tenant/configuration/${name}`;
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const putTenantConfiguration: WrappedCashifyFunction<
  { name: string; updates: StandardObject },
  CommonResponse
> = ({ urlPrefix, options }) => {
  return async ({ name, updates }) => {
    let url = `${urlPrefix}/api/v1/tenant/configuration/${name}`;
    let opts = extendFetchOptions(
      {
        method: "PUT",
        headers: {
          ...getDefaultHeaders(),
          "Content-Type": "application/merge-patch+json",
        },
        body: JSON.stringify({ updates }),
      },
      options
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const putTenantConfigurationStatus: WrappedCashifyFunction<
  { name: string; enabled: boolean },
  CommonResponse
> = ({ urlPrefix, options }) => {
  return async ({ name, enabled }) => {
    let url = `${urlPrefix}/api/v1/tenant/configuration/${name}/status`;
    let opts = extendFetchOptions(
      {
        method: "PUT",
        headers: {
          ...getDefaultHeaders(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ enabled }),
      },
      options
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const performDryrun: WrappedCashifyFunction<
  { configurationName: string, service: string, configuration: StandardObject },
  GenericResponse<StandardObject>
> = ({ urlPrefix, options }) => {
  return async ({ configurationName, service, configuration }) => {
    let url = `${urlPrefix}/api/v1/tenant/configuration/dry-run`;
    let opts = extendFetchOptions(
      {
        method: "POST",
        body: JSON.stringify({ configurationName, service, configuration }),
        headers: {
          ...getDefaultHeaders(),
          "Content-Type": "application/json",
        },
      },
      options
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};
